var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.6 29.8 9.4-3c.4 0 .6-.2.8-.4L29.4 12c.8-.8.8-2 0-2.8L23 2.7c-.8-.8-2-.8-2.8 0L5.6 17.2c-.2.2-.4.4-.4.8l-3 9.4c-.4 1 .2 2.2 1.4 2.6.2 0 .8 0 1-.2m4.2-10.3L21.4 6.9l3.6 3.6-12.6 12.6-5.2 1.6c0 .1 1.6-5.2 1.6-5.2"
  })));
};
export default SvgEdit;